import { render, staticRenderFns } from "./ViewFeedbackModal.vue?vue&type=template&id=7b503d50&scoped=true"
import script from "./ViewFeedbackModal.vue?vue&type=script&lang=js"
export * from "./ViewFeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./ViewFeedbackModal.vue?vue&type=style&index=0&id=7b503d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b503d50",
  null
  
)

export default component.exports